module.exports = __webpack_public_path__ + "0499c8e13bed8941941377728c5d59e2.svg";